module.exports = __webpack_public_path__ + "img/calculator@2x.07c1bd5.png";